import { Paper, TablePagination } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import toastr from "toastr";
import {
    deleteOrganisation, getAdminOrganisations, resetResponseState, setCurrentAdminOrganisation, setLoading, unsetLoading,
    setCurrentAdminOffice, deleteOffice
} from '../../../store/appAction';
import DeleteModal from '../../../components/Modal/DeleteModal';
import { toastrCustomOptions, toastrCustomOptionsLonger } from '../../../constants/toastrOptions';
import { OrgTreeView } from './OrgTreeView';
import AgcIconButton from '../../../components/Buttons/AgcIconButton';
import {AgcAlert} from '../../../components/Alerts/AgcAlert';
import SearchField from '../../../components/Inputs/SearchField';
import { stripNonPrintable } from '../../../helpers/stringFormatHelper';
import { isObjectEmptyOrNull } from '../../../helpers/genericHelper';

//TODO: Address pagination. Replace the use of Redux with something else (Tanstack query?)

const mergeOfficeOrgTree = (officeList, officeData) => {
    if (officeData) {
        for (const o of officeData) {
            let match = officeList?.find((office) => { return o.id === office.id })
            if (match) {
                match.label = o.officeName;
                match.logoURL = o.officeLogoUrl;
                match.userCount = o.userCount;
                match.farmCount = o.farmCount;
            } else {
                officeList.push({
                    id: o.id,
                    label: o.officeName,
                    logoURL: o.officeLogoUrl,
                    userCount: o.userCount,
                    farmCount: o.farmCount,
                    type: 'office'
                })
            }
        }
    }
    officeList.sort((a, b) => a.label.localeCompare(b.label, undefined, { ignorePunctuation: true }))
    return officeList;
}
const mergeOrgTree = (orgTree, orgData) => {
    if (orgData) {
        for (const o of orgData) {
            let match = orgTree.find((ot) => { return o.id === ot.id })
            if (match) {
                match.label = o.organizationName;
                match.logoURL = o.organizationLogoUrl;
                match.userCount = o.userCount;
                match.farmCount = o.farmCount;
                match.officeCount = o.officeCount;
                mergeOfficeOrgTree(match.children, o.offices)

            } else {
                orgTree.push({
                    id: o.id,
                    label: o.organizationName,
                    logoURL: o.organizationLogoUrl,
                    userCount: o.userCount,
                    farmCount: o.farmCount,
                    officeCount: o.officeCount,
                    type: 'organisation',
                    children: mergeOfficeOrgTree([], o.offices)
                })
            }
        }
    }
    orgTree.sort((a, b) => a.label.localeCompare(b.label, undefined, { ignorePunctuation: true }))
    return orgTree;
}


const Organisations = () => {
    toastr.options = toastrCustomOptions;
    let navigate = useNavigate();
    const dispatch = useDispatch();

    const { successMsg, errorMsg, loading } = useSelector(state => state.common);

    const organisationList = useSelector(state => state.adminOrganisation.organisations);

    // const [page, setPage] = useState(0);
    // const [rowsPerPage, setRowsPerPage] = useState(10);
    // const [searchQuery, setSearchQuery] = useState({
    //     sorting: null,
    //     sortOrder: 'ASC',
    //     skipCount: 0,
    //     maxResultCount: 25
    // });
    // const [pagination, setPagination] = useState({
    //     page: 0,
    //     rowsPerPage: 25
    // });

    const searchQuery = {
        name: null,
        sorting: null,
        sortOrder: 'ASC',
        skipCount: 0,
        maxResultCount: 2500
    }

    const [organisationsTree, setOrganisationsTree] = useState([]);
    const [searchTerm, setSearchTerm] = useState(searchQuery);
    const [backgroundLoading, setBackgroundLoading] = useState(false);
    const [lastSearchEmpty, setLastSearchEmpty] = useState(false)

    const [selectedOrganization, setSelectedOrganization] = useState(null);
    const [selectedOffice, setSelectedOffice] = useState(null);

    const [modalDeleteConfirmMessage, setModalDeleteConfirmMessage] = useState('Are you sure you wish to delete this organisation?');
    const [modalDeleteConfirm, setModalDeleteConfirm] = useState(false);

    useEffect(() => {
        dispatch(setLoading());
        dispatch(setCurrentAdminOrganisation({}));
        dispatch(setCurrentAdminOffice({}));
        dispatch(getAdminOrganisations(searchTerm));
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //     const { page, rowsPerPage } = pagination;

    //     !loading && organisationList && setSearchQuery(prevState => ({
    //         ...prevState,
    //         skipCount: page * rowsPerPage,
    //         maxResultCount: rowsPerPage
    //     }));

    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [pagination]);

    useEffect(() => {
        organisationList && setTimeout(() => {
            dispatch(unsetLoading());
        }, 200);
        setBackgroundLoading(false)
        //setOrganisationsTree(mergeOrgTree([...organisationsTree], organisationList))
        setOrganisationsTree(mergeOrgTree([], organisationList?.items))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [organisationList]);

    useEffect(() => {
        if (successMsg || errorMsg) {
            dispatch(unsetLoading());
            if (successMsg) {
                toastr.success(successMsg);
                setBackgroundLoading(true)
                dispatch(setCurrentAdminOrganisation({}));
                dispatch(setCurrentAdminOffice({}));
                dispatch(getAdminOrganisations(searchTerm));
            }
            errorMsg && toastr.error(errorMsg, undefined, toastrCustomOptionsLonger);
            dispatch(resetResponseState());
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [successMsg, errorMsg]);

    const handleSearch = (txt) => {
        let sc={...searchTerm}
        sc.name = stripNonPrintable(txt)
        setSearchTerm(sc)
        setBackgroundLoading(true)
        setSelectedOrganization(null);
        setSelectedOffice(null);
        dispatch(setCurrentAdminOrganisation({}));
        dispatch(setCurrentAdminOffice({}));
        dispatch(getAdminOrganisations(sc))
    }

    const handleOrganisationSelected = (e, item) => {
        let orgData = organisationList?.items?.find((o) => (o.id === item));
        if (orgData) {
            dispatch(setCurrentAdminOrganisation(orgData));
            setSelectedOrganization(orgData);
            setSelectedOffice(null);
            dispatch(setCurrentAdminOffice({}));
        } else { // might have selected an office
            // check in the currently selectedOrg
            let orgsWithOffice = organisationList?.items?.filter((o) => (o.officeCount>0));
            let office = null;
            let orgWithOffice = orgsWithOffice?.find((o) => {
                office = o.offices.find((office) => (office.id === item));
                return office!==null;
            })
            if(orgWithOffice){
                //set the org and the office
                dispatch(setCurrentAdminOrganisation(orgWithOffice));
                setSelectedOrganization(orgWithOffice);
                setSelectedOffice(office);
                dispatch(setCurrentAdminOffice(office));
            }else{
                dispatch(setCurrentAdminOrganisation({}));
                setSelectedOrganization(null);
            }
        }
    }

    const handleOrganisationCreate = () => {
        dispatch(setCurrentAdminOrganisation({}));
        setSelectedOrganization(null);
        navigate('/admin/organisations/create')
    }

    const handleOrganisationEditDetails = (e) => {
        //admin org already set in the select handler
        navigate('/admin/organisations/edit')
    }

    const handleOfficeCreate = () => {
        // Admin org  must already be set and the office cleared
        // (on the select handler)
        navigate('/admin/offices/create')
    }

    const handleOfficeEditDetails = (e) => {
        // Admin org and admin office must already be set 
        // (on the select handler)
        navigate('/admin/offices/edit')
    }

    const handleOfficeDelete = async (e) => {
       
        const farms = `<BR/>Will unlink ${selectedOffice.farmCount} Farms.`;
        let mesg = `Are you sure you want to delete ${selectedOffice.officeName} (in ${selectedOffice.organizationName})?`;
        mesg += selectedOffice.farmCount ? farms : '';

        setModalDeleteConfirmMessage(mesg)
        setModalDeleteConfirm(true);
      };

    const handleOrgDelete = async (e) => {

        const farms = `<BR/>Will unlink ${selectedOrganization.farmCount} Farms.`;
        const offices = `<BR/>Will delete ${selectedOrganization.officeCount} Offices.`;

        let mesg = `Are you sure you want to delete ${selectedOrganization.organizationName}?`;
        mesg += selectedOrganization.farmCount ? farms : '';
        mesg += selectedOrganization.officeCount ? offices : '';

        setModalDeleteConfirmMessage(mesg)
        setModalDeleteConfirm(true);
    }

    const handleDeleteModalConfirm = async (positiveResponse) => {
        // by the time we get here either an org or an office has been selected
        // Checks to dtermine if it can be deleted have been done before the relevant
        // delete button was made active so all that needs done here is to delete the organisation
        // or the office 
        setModalDeleteConfirm(false);
        if (positiveResponse) {
            dispatch(setLoading());
            if(!selectedOffice){
                // office not selected so we delete the org
                dispatch(deleteOrganisation());
                dispatch(setCurrentAdminOrganisation({}));
                setSelectedOrganization(null);
            } else {
                // user has selected an office so this must be to delete the office
                dispatch(deleteOffice());
                dispatch(setCurrentAdminOffice({}));
                setSelectedOffice(null);
            }
        } else {
            dispatch(unsetLoading());
        }
    }

    // const handleChangePage = (e, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = (e) => {
    //     setRowsPerPage(parseInt(e.target.value, 10));
    //     setPage(0);
    // };

    const orgHasUsers = selectedOrganization?.userCount > 0

    const disableOrgDelete = isObjectEmptyOrNull(selectedOrganization) || orgHasUsers
    let deleteOrgMesg = "Delete Organisation"
    if (orgHasUsers) {
        deleteOrgMesg = "Can't delete Organisation with Users!"
    }
    if (isObjectEmptyOrNull(selectedOrganization)) {
        deleteOrgMesg += "(Select an Organisation first)"
    }

    const officeHasUsers = selectedOffice?.userCount > 0
    const disableOfficeDelete = isObjectEmptyOrNull(selectedOffice) || officeHasUsers

    let deleteOfficeMesg = "Delete Office"
    if (officeHasUsers) {
        deleteOfficeMesg = "Can't delete Office with Users!"
    }
    if (isObjectEmptyOrNull(selectedOffice)) {
        deleteOfficeMesg += "(Select an Office first)"
    }

    let selectedItem = ''
    let isOfficeSelected = false
    let isOrgSelected = false
    if(selectedOffice){
        selectedItem = selectedOffice.id
        isOfficeSelected = true
    }else if(selectedOrganization){
        selectedItem = selectedOrganization.id
        isOrgSelected = true
    }

    let showInfoMessage = backgroundLoading===false && organisationList?.totalCount ===0
    let noOrgsMesg = `Did not find organisation(s) or office(s) named '${searchTerm?.name}'.`
    return (
        <Stack spacing={1} >
            <Stack direction="row" spacing={0} sx={{ width: { xs: "100%", sm: "75%", md: "75%", lg: "40%" } }}>
                <AgcIconButton
                    aria-label="create"
                    onClick={handleOrganisationCreate}
                    tooltip='Create Organisation'
                    iconType='Add'
                    iconColor='action' />
                <AgcIconButton
                    tooltip={deleteOrgMesg}
                    aria-label="delete"
                    size="large"
                    onClick={handleOrgDelete}
                    disabled={disableOrgDelete}
                    iconType='Delete'
                    iconColor={disableOrgDelete ? 'disabled' : 'action'} />
                <AgcIconButton
                    tooltip={`Edit Organisation${isOrgSelected? '':' (Select an Organisation first)'}`}
                    aria-label="edit"
                    size="large"
                    onClick={handleOrganisationEditDetails}
                    disabled={!isOrgSelected}
                    iconType='Edit'
                    iconColor={isOrgSelected ? 'action':'disabled' } />
                <AgcIconButton
                    aria-label="create-office"
                    onClick={handleOfficeCreate}
                    disabled={!isOrgSelected}
                    tooltip='Create Office'
                    iconType='AddOffice'
                    iconColor={isOrgSelected ? 'action':'disabled'} />
                <AgcIconButton
                    aria-label="delete-office"
                    onClick={handleOfficeDelete}
                    tooltip={deleteOfficeMesg}
                    disabled={disableOfficeDelete}
                    iconType='DeleteOffice'
                    iconColor={disableOfficeDelete ? 'disabled':'action'} />
                <AgcIconButton
                    aria-label="edit-office"
                    onClick={handleOfficeEditDetails}
                    disabled={!isOfficeSelected}
                    tooltip={`Edit Office${isOfficeSelected ? '':' (Select an Office first)'}`}
                    iconType='EditOffice'
                    iconColor={isOfficeSelected ? 'action':'disabled'} />
            </Stack>
            <SearchField onSearch={handleSearch} backgroundLoading={backgroundLoading}/>
            <AgcAlert open={showInfoMessage} severity='info' message={noOrgsMesg}/>
            <OrgTreeView treeData={organisationsTree}
                selectedItems={selectedItem}
                onSelectedItemsChange={handleOrganisationSelected}

                page={0/*page*/} rowsPerPage={1000/*rowsPerPage*/} 
                disable= {backgroundLoading}/>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', width: '50%' }}>
                {/*<TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={organisationList?.length || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        disabled={!loading}
                    />*/}
                <DeleteModal
                    isOpen={modalDeleteConfirm}
                    handleResponse={handleDeleteModalConfirm}
                    value={modalDeleteConfirmMessage}
                />
            </Paper>
        </Stack >
    )
}

export default Organisations